import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify"
import "./ThemeSettings.css";
import CameraRetroIcon from "@rsuite/icons/legacy/CameraRetro";

import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader"
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import { IoClose } from "react-icons/io5";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import { useMyContext } from "../../../components/Provider/CommonProvider";

function ThemeSettings() {

  const access_token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  const { fetchRequest, globalImageUplaodAPI } = useMyContext();
  const imageApi = globalImageUplaodAPI();
  const [loading, setLoading] = useState(true);
  const [selectedFile1, setSelectedFile1] = useState(null);
  const [selectedFile2, setSelectedFile2] = useState(null);
  const [selectedFile3, setSelectedFile3] = useState(null);
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [themeList, setThemeList] = useState([])
  const [editUser, setEditUser] = useState({
    button_bg_color: '#000',
    light_bg_color: '#000',
    dark_bg_color: '#000',
    dark_text_color: '#000',
    light_text_color: '#000',
    admin_dark_bg_color: '#000',
    admin_light_bg_color: '#000',
    admin_dark_text_color: '#000',
    admin_light_text_color: '#000',
    light_bg_secondary_color: '#000',
    dark_bg_secondary_color: '#000',
    admin_dark_button_bg_color: '#000',
    admin_light_button_bg_color: '#000',
    admin_dark_button_text_color: '#000',
    admin_light_button_text_color: '#000',
    dark_button_bg_color: '#000',
    light_button_bg_color: '#000',
    dark_button_text_color: '#000',
    light_button_text_color: '#000',
    signup_step2_title: 0,
    signup_theme: 0,
    signup_payment_content: 0,
    prevent_inspect: 0,
    loader_setting: 0,
    style_sheet_link: 0,
    typography_link: 0,
    my_profile_theme: 0,
    audio_page_checkout: 0,
    signin_header: 0,
    choose_player: 0,
    Vod_Aod_checkout: 0,
    translate_checkout: 0,
    audio_content_right_checkout: 0,
    enable_slider: 0,
    current_theme: 0,
    subscription_flag: 0,
    disable_login: 0,
    radiostation_active: 0,
    category_hover: 0,
    trailer_hover: 0,
    enable_category_tab: 0,
    enable_image_cropping: 0,
    enable_epg: 0,
    ssai_enable: 0,
    enable_trailer_banner: 0,
    partner_approval: 1,
    partner_content_approval: 1,
    disable_divider: 0,
    disable_404_screen: 0,
  });

  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);
  const fileInputRef3 = useRef(null);

  const [error1, setError1] = useState("");
  const [error2, setError2] = useState("");

  const handleFileChange = (event, fileInputRef, setSelectedFile, setError, checkRatio = true) => {
    const file = event.target.files[0];
    if (setError) setError(""); // clear old error

    if (!file || !file.type.startsWith("image/")) {
      if (setError) setError("Only image files are allowed.");
      fileInputRef.current.value = null;
      return;
    }

    if (!checkRatio) {
      setSelectedFile(file);
      return;
    }

    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      const { width, height } = img;
      const isExact = width === 200 && height === 40;
      const isRatio = Math.round((width / height) * 10) === 50;

      if (isExact || isRatio) {
        setSelectedFile(file);
        if (setError) setError("");
      } else {
        setSelectedFile(null);
        if (setError) setError("Image must be 200x40px or have a 5:1 aspect ratio.");
        fileInputRef.current.value = null;
      }

      URL.revokeObjectURL(objectUrl);
    };

    img.onerror = () => {
      if (setError) setError("Invalid image file.");
      fileInputRef.current.value = null;
      URL.revokeObjectURL(objectUrl);
    };

    img.src = objectUrl;
  };


  const handleDelete = (index) => {
    switch (index) {
      case 1:
        setSelectedFile1(null);
        if (fileInputRef1.current) {
          fileInputRef1.current.value = null;
        }
        break;
      case 2:
        setSelectedFile2(null);
        if (fileInputRef2.current) {
          fileInputRef2.current.value = null;
        }
        break;
      case 3:
        setSelectedFile3(null);
        if (fileInputRef3.current) {
          fileInputRef3.current.value = null;
        }
        break;
      default:
        break;
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setEditUser((prevEditUser) => ({
      ...prevEditUser,
      [name]: value,
    }));
  };

  const handleInputenable = (e) => {
    if (e.target.checked === true) {
      setEditUser({ ...editUser, [e.target.name]: 1 });
    } else {
      setEditUser({ ...editUser, [e.target.name]: 0 });
    }
  };

  const fetchData = async () => {
    try {
      await axios.get(`${process.env.REACT_APP_Baseurl}/admin/Site-ThemeSetting/index`, { headers: headers })
        .then((res) => {
          var theme = res?.data?.Site_theme_setting[0];
          setEditUser(theme);
          setThemeList(res?.data?.themes);
          setLoading(false);
        });
    }
    catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    if (access_token) {
      fetchData()
    }
  }, [withOutRefresh, access_token]);

  const handleSave = async () => {
    setShowOverlay(true);
    const formData = new FormData();
    for (const key in editUser) {
      formData.append(key, editUser[key]);
    }
    // formData.append("dark_mode_logo", selectedFile1);
    // formData.append("light_mode_logo", selectedFile2);
    formData.append("loading_gif_video", selectedFile3);
    try {
      const response = await axios.patch(`${process.env.REACT_APP_Baseurl}/admin/Site-ThemeSetting/update`, formData, { headers: headers });
      const result = response?.data
      if (result?.status) {
        toast.success(result?.message)
        const imageFormData = new FormData();
        const modelName = "SiteTheme";
        const id = editUser?.id;

        imageFormData.append("id", id);
        imageFormData.append("modelName", modelName);

        const imageFields = [];
        if (selectedFile1) {
          imageFormData.append("dark_mode_logo", selectedFile1);
          imageFields.push("dark_mode_logo");
        }
        if (selectedFile2) {
          imageFormData.append("light_mode_logo", selectedFile2);
          imageFields.push("light_mode_logo");
        }

        if (selectedFile3) {
          imageFormData.append("loading_gif_video", selectedFile3);
          imageFields.push("loading_gif_video");
        }

        if (imageFields.length > 0) {
          imageFields.forEach((field) => {
            imageFormData.append("imageFields[]", field);
          });
          await fetchRequest({
            method: 'POST',
            url: imageApi,
            data: imageFormData,
          });
        }
        setShowOverlay(false);
        setSelectedFile1(null)
        setSelectedFile2(null)
        setSelectedFile3(null)
        setWithOutRefresh(!withOutRefresh)
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message
      toast.error(errorMessage)
    }
  }
  return (
    <>
      {showOverlay && <Response_Processing></Response_Processing>}
      <AdminSaveHeader heading="Theme Settings" saveText="Update Settings" saveMethod={handleSave} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text="Checkout Theme" />
            <MessageLabel text="Signup page title" className='' />
            <AdminCustomInput type="text" id="signup_step2_title" name="signup_step2_title" value={editUser?.signup_step2_title} onChange={handleInput} />
            <MessageLabel text="Signup agree message" />
            <AdminCustomInput type="text" id="signup_payment_content" name="signup_payment_content" placeHolder={"Enter signup agree message"} value={editUser?.signup_payment_content} onChange={handleInput} />
          </Wrapper>

          {/* Site Bg color start */}
          <Wrapper>
            <MessageHeading text="Site Background color" />
            <div className="d-flex align-items-center justify-content-between flex-wrap  ">
              <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                <MessageLabel text="Dark Mode" className='text-sm-start pb-2' />
                <div className="d-flex align-items-center gap-3 justify-content-sm-start pe-sm-2">
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Primary" />
                    <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0 border colorPicker"
                        id="dark_bg_color"
                        name="dark_bg_color"
                        onChange={handleInput}
                        value={editUser?.dark_bg_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary  d-block  w-100 rounded-1 p-2" name="dark_bg_color" onChange={handleInput} value={editUser?.dark_bg_color}></input>
                    </div>
                  </div>

                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Secondary" />
                    <div className="mt-2  overflow-hidden shadow  rounded-2">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker "
                        id="dark_bg_secondary_color"
                        name="dark_bg_secondary_color"
                        onChange={handleInput}
                        value={editUser?.dark_bg_secondary_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="dark_bg_secondary_color" onChange={handleInput} value={editUser?.dark_bg_secondary_color}></input>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <MessageLabel text="Light Mode" className='text-sm-end pb-2' />
                <div className="d-flex align-items-center gap-3 justify-content-sm-end ps-sm-2">
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Primary" />
                    <div className="mt-2  overflow-hidden shadow  rounded-2">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker "
                        id="light_bg_color"
                        name="light_bg_color"
                        onChange={handleInput}
                        value={editUser?.light_bg_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="light_bg_color" onChange={handleInput} value={editUser?.light_bg_color}></input>
                    </div>
                  </div>
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Secondary" />
                    <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0 border colorPicker"
                        id="light_bg_secondary_color"
                        name="light_bg_secondary_color"
                        onChange={handleInput}
                        value={editUser?.light_bg_secondary_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary  d-block  w-100 rounded-1 p-2" name="light_bg_secondary_color" onChange={handleInput} value={editUser?.light_bg_secondary_color}></input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Wrapper>
          {/* Site Bg color end */}

          {/* Site Text color start */}
          <Wrapper>
            <MessageHeading text="Site Text color" />
            <div className="d-flex align-items-center justify-content-between flex-wrap  ">
              <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                <MessageLabel text="Dark Mode" className='text-sm-start pb-2' />
                <div className="d-flex align-items-center gap-3 justify-content-sm-start pe-sm-2">
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Primary" />
                    <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0 border colorPicker"
                        id="dark_text_color"
                        name="dark_text_color"
                        onChange={handleInput}
                        value={editUser?.dark_text_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary  d-block  w-100 rounded-1 p-2" name="dark_text_color" onChange={handleInput} value={editUser?.dark_text_color}></input>
                    </div>
                  </div>

                  {/* <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Secondary" />
                    <div className="mt-2  overflow-hidden shadow  rounded-2">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker "
                        id="dark_bg_secondary_color"
                        name="dark_bg_secondary_color"
                        onChange={handleInput}
                        value={editUser?.dark_bg_secondary_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="dark_bg_secondary_color" onChange={handleInput} value={editUser?.dark_bg_secondary_color}></input>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <MessageLabel text="Light Mode" className='text-sm-end pb-2' />
                <div className="d-flex align-items-center gap-3 justify-content-sm-end ps-sm-2">
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Primary" />
                    <div className="mt-2  overflow-hidden shadow  rounded-2">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker "
                        id="light_text_color"
                        name="light_text_color"
                        onChange={handleInput}
                        value={editUser?.light_text_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="light_text_color" onChange={handleInput} value={editUser?.light_text_color}></input>
                    </div>
                  </div>
                  {/* <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Secondary" />
                    <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0 border colorPicker"
                        id="light_bg_secondary_color"
                        name="light_bg_secondary_color"
                        onChange={handleInput}
                        value={editUser?.light_bg_secondary_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary  d-block  w-100 rounded-1 p-2" name="light_bg_secondary_color" onChange={handleInput} value={editUser?.light_bg_secondary_color}></input>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

          </Wrapper>
          {/* Site Text color end */}
          {/* site Bg  button color start */}
          <Wrapper>
            <MessageHeading text="Site Button Bg color" />
            <div className="d-flex align-items-center justify-content-between flex-wrap  ">
              <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                <MessageLabel text="Dark Mode" className='text-sm-start pb-2' />
                <div className="d-flex align-items-center gap-3 justify-content-sm-start pe-sm-2 ">
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Primary" />
                    <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker"
                        id="dark_button_bg_color"
                        name="dark_button_bg_color"
                        onChange={handleInput}
                        value={editUser?.dark_button_bg_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="dark_button_bg_color" onChange={handleInput} value={editUser?.dark_button_bg_color}></input>
                    </div>
                  </div>

                  {/* <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Secondary color" />
                    <div className="mt-2  overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker "
                        id="admin_dark_bg_secondary_color"
                        name="admin_dark_bg_secondary_color"
                        onChange={handleInput}
                        value={editUser?.admin_dark_bg_secondary_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="admin_dark_bg_secondary_color" onChange={handleInput} value={editUser?.admin_dark_bg_secondary_color}></input>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <MessageLabel text="Light Mode" className='text-sm-end pb-2' />
                <div className="d-flex align-items-center gap-3 justify-content-sm-end ps-sm-2">
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Primary" />
                    <div className="mt-2  overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker "
                        id="light_button_bg_color"
                        name="light_button_bg_color"
                        onChange={handleInput}
                        value={editUser?.light_button_bg_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="light_button_bg_color" onChange={handleInput} value={editUser?.light_button_bg_color}></input>
                    </div>
                  </div>
                  {/* <div className="pickerWidth">
                   <MessageSubHeading className="colorText text-center" text="Secondary" />
                  <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                    <input
                      type="color"
                      className="rs-input form-control-lg p-0  colorPicker"
                      id="admin_light_bg_secondary_color"
                      name="admin_light_bg_secondary_color"
                      onChange={handleInput}
                      value={editUser?.admin_light_bg_secondary_color}
                    />
                    <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="admin_light_bg_secondary_color" onChange={handleInput} value={editUser?.admin_light_bg_secondary_color}></input>
                  </div>
                </div> */}
                </div>
              </div>
            </div>
          </Wrapper>

          {/* site Bg button color end */}


          {/* site button Text color start */}
          <Wrapper>
            <MessageHeading text="Site Button Text color" />
            <div className="d-flex align-items-center justify-content-between flex-wrap  ">
              <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                <MessageLabel text="Dark Mode" className='text-sm-start pb-2' />
                <div className="d-flex align-items-center gap-3 justify-content-sm-start pe-sm-2">
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Primary" />
                    <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0 border colorPicker"
                        id="dark_button_text_color"
                        name="dark_button_text_color"
                        onChange={handleInput}
                        value={editUser?.dark_button_text_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary  d-block  w-100 rounded-1 p-2" name="dark_button_text_color" onChange={handleInput} value={editUser?.dark_button_text_color}></input>
                    </div>
                  </div>

                  {/* <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Secondary" />
                    <div className="mt-2  overflow-hidden shadow  rounded-2">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker "
                        id="dark_bg_secondary_color"
                        name="dark_bg_secondary_color"
                        onChange={handleInput}
                        value={editUser?.dark_bg_secondary_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="dark_bg_secondary_color" onChange={handleInput} value={editUser?.dark_bg_secondary_color}></input>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <MessageLabel text="Light Mode" className='text-sm-end pb-2' />
                <div className="d-flex align-items-center gap-3 justify-content-sm-end ps-sm-2">
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Primary" />
                    <div className="mt-2  overflow-hidden shadow  rounded-2">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker "
                        id="light_button_text_color"
                        name="light_button_text_color"
                        onChange={handleInput}
                        value={editUser?.light_button_text_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="light_button_text_color" onChange={handleInput} value={editUser?.light_button_text_color}></input>
                    </div>
                  </div>
                  {/* <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Secondary" />
                    <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0 border colorPicker"
                        id="light_bg_secondary_color"
                        name="light_bg_secondary_color"
                        onChange={handleInput}
                        value={editUser?.light_bg_secondary_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary  d-block  w-100 rounded-1 p-2" name="light_bg_secondary_color" onChange={handleInput} value={editUser?.light_bg_secondary_color}></input>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

          </Wrapper>
          {/* site button Text color end */}

          {/* Admin Bg color start */}
          <Wrapper>
            <MessageHeading text="Admin Background color" />
            <div className="d-flex align-items-center justify-content-between flex-wrap  ">
              <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                <MessageLabel text="Dark Mode" className='text-sm-start pb-2' />
                <div className="d-flex align-items-center gap-3 justify-content-sm-start pe-sm-2 ">
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Primary" />
                    <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker"
                        id="admin_dark_bg_color"
                        name="admin_dark_bg_color"
                        onChange={handleInput}
                        value={editUser?.admin_dark_bg_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="admin_dark_bg_color" onChange={handleInput} value={editUser?.admin_dark_bg_color}></input>
                    </div>
                  </div>

                  {/* <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Secondary color" />
                    <div className="mt-2  overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker "
                        id="admin_dark_bg_secondary_color"
                        name="admin_dark_bg_secondary_color"
                        onChange={handleInput}
                        value={editUser?.admin_dark_bg_secondary_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="admin_dark_bg_secondary_color" onChange={handleInput} value={editUser?.admin_dark_bg_secondary_color}></input>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <MessageLabel text="Light Mode" className='text-sm-end pb-2' />
                <div className="d-flex align-items-center gap-3 justify-content-sm-end ps-sm-2">
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Primary" />
                    <div className="mt-2  overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker "
                        id="admin_light_bg_color"
                        name="admin_light_bg_color"
                        onChange={handleInput}
                        value={editUser?.admin_light_bg_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="admin_light_bg_color" onChange={handleInput} value={editUser?.admin_light_bg_color}></input>
                    </div>
                  </div>
                  {/* <div className="pickerWidth">
                   <MessageSubHeading className="colorText text-center" text="Secondary" />
                  <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                    <input
                      type="color"
                      className="rs-input form-control-lg p-0  colorPicker"
                      id="admin_light_bg_secondary_color"
                      name="admin_light_bg_secondary_color"
                      onChange={handleInput}
                      value={editUser?.admin_light_bg_secondary_color}
                    />
                    <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="admin_light_bg_secondary_color" onChange={handleInput} value={editUser?.admin_light_bg_secondary_color}></input>
                  </div>
                </div> */}
                </div>
              </div>
            </div>
          </Wrapper>

          {/* Admin Bg color end */}
          {/* Admin Text color start */}
          <Wrapper>
            <MessageHeading text="Admin Text color" />
            <div className="d-flex align-items-center justify-content-between flex-wrap  ">
              <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                <MessageLabel text="Dark Mode" className='text-sm-start pb-2' />
                <div className="d-flex align-items-center gap-3 justify-content-sm-start pe-sm-2">
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Primary" />
                    <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0 border colorPicker"
                        id="admin_dark_text_color"
                        name="admin_dark_text_color"
                        onChange={handleInput}
                        value={editUser?.admin_dark_text_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary  d-block  w-100 rounded-1 p-2" name="admin_dark_text_color" onChange={handleInput} value={editUser?.admin_dark_text_color}></input>
                    </div>
                  </div>

                  {/* <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Secondary" />
                    <div className="mt-2  overflow-hidden shadow  rounded-2">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker "
                        id="dark_bg_secondary_color"
                        name="dark_bg_secondary_color"
                        onChange={handleInput}
                        value={editUser?.dark_bg_secondary_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="dark_bg_secondary_color" onChange={handleInput} value={editUser?.dark_bg_secondary_color}></input>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <MessageLabel text="Light Mode" className='text-sm-end pb-2' />
                <div className="d-flex align-items-center gap-3 justify-content-sm-end ps-sm-2">
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Primary" />
                    <div className="mt-2  overflow-hidden shadow  rounded-2">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker "
                        id="admin_light_text_color"
                        name="admin_light_text_color"
                        onChange={handleInput}
                        value={editUser?.admin_light_text_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="admin_light_text_color" onChange={handleInput} value={editUser?.admin_light_text_color}></input>
                    </div>
                  </div>
                  {/* <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Secondary" />
                    <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0 border colorPicker"
                        id="light_bg_secondary_color"
                        name="light_bg_secondary_color"
                        onChange={handleInput}
                        value={editUser?.light_bg_secondary_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary  d-block  w-100 rounded-1 p-2" name="light_bg_secondary_color" onChange={handleInput} value={editUser?.light_bg_secondary_color}></input>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

          </Wrapper>
          {/* Admin Text color end */}

          {/* Admin Bg  button color start */}
          <Wrapper>
            <MessageHeading text="Admin Button Bg color" />
            <div className="d-flex align-items-center justify-content-between flex-wrap  ">
              <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                <MessageLabel text="Dark Mode" className='text-sm-start pb-2' />
                <div className="d-flex align-items-center gap-3 justify-content-sm-start pe-sm-2 ">
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Primary" />
                    <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker"
                        id="admin_dark_button_bg_color"
                        name="admin_dark_button_bg_color"
                        onChange={handleInput}
                        value={editUser?.admin_dark_button_bg_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="admin_dark_button_bg_color" onChange={handleInput} value={editUser?.admin_dark_button_bg_color}></input>
                    </div>
                  </div>

                  {/* <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Secondary color" />
                    <div className="mt-2  overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker "
                        id="admin_dark_bg_secondary_color"
                        name="admin_dark_bg_secondary_color"
                        onChange={handleInput}
                        value={editUser?.admin_dark_bg_secondary_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="admin_dark_bg_secondary_color" onChange={handleInput} value={editUser?.admin_dark_bg_secondary_color}></input>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <MessageLabel text="Light Mode" className='text-sm-end pb-2' />
                <div className="d-flex align-items-center gap-3 justify-content-sm-end ps-sm-2">
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Primary" />
                    <div className="mt-2  overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker "
                        id="admin_light_button_bg_color"
                        name="admin_light_button_bg_color"
                        onChange={handleInput}
                        value={editUser?.admin_light_button_bg_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="admin_light_button_bg_color" onChange={handleInput} value={editUser?.admin_light_button_bg_color}></input>
                    </div>
                  </div>
                  {/* <div className="pickerWidth">
                   <MessageSubHeading className="colorText text-center" text="Secondary" />
                  <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                    <input
                      type="color"
                      className="rs-input form-control-lg p-0  colorPicker"
                      id="admin_light_bg_secondary_color"
                      name="admin_light_bg_secondary_color"
                      onChange={handleInput}
                      value={editUser?.admin_light_bg_secondary_color}
                    />
                    <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="admin_light_bg_secondary_color" onChange={handleInput} value={editUser?.admin_light_bg_secondary_color}></input>
                  </div>
                </div> */}
                </div>
              </div>
            </div>
          </Wrapper>

          {/* Admin Bg button color end */}


          {/* Admin button Text color start */}
          <Wrapper>
            <MessageHeading text="Admin Button Text color" />
            <div className="d-flex align-items-center justify-content-between flex-wrap  ">
              <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                <MessageLabel text="Dark Mode" className='text-sm-start pb-2' />
                <div className="d-flex align-items-center gap-3 justify-content-sm-start pe-sm-2">
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Primary" />
                    <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0 border colorPicker"
                        id="admin_dark_button_text_color"
                        name="admin_dark_button_text_color"
                        onChange={handleInput}
                        value={editUser?.admin_dark_button_text_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary  d-block  w-100 rounded-1 p-2" name="admin_dark_button_text_color" onChange={handleInput} value={editUser?.admin_dark_button_text_color}></input>
                    </div>
                  </div>

                  {/* <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Secondary" />
                    <div className="mt-2  overflow-hidden shadow  rounded-2">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker "
                        id="dark_bg_secondary_color"
                        name="dark_bg_secondary_color"
                        onChange={handleInput}
                        value={editUser?.dark_bg_secondary_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="dark_bg_secondary_color" onChange={handleInput} value={editUser?.dark_bg_secondary_color}></input>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <MessageLabel text="Light Mode" className='text-sm-end pb-2' />
                <div className="d-flex align-items-center gap-3 justify-content-sm-end ps-sm-2">
                  <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Primary" />
                    <div className="mt-2  overflow-hidden shadow  rounded-2">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0  colorPicker "
                        id="admin_light_button_text_color"
                        name="admin_light_button_text_color"
                        onChange={handleInput}
                        value={editUser?.admin_light_button_text_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="admin_light_button_text_color" onChange={handleInput} value={editUser?.admin_light_button_text_color}></input>
                    </div>
                  </div>
                  {/* <div className="pickerWidth">
                    <MessageSubHeading className="colorText text-center" text="Secondary" />
                    <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                      <input
                        type="color"
                        className="rs-input form-control-lg p-0 border colorPicker"
                        id="light_bg_secondary_color"
                        name="light_bg_secondary_color"
                        onChange={handleInput}
                        value={editUser?.light_bg_secondary_color}
                      />
                      <input type="text" className="showCode theme-bg-color-secondary  d-block  w-100 rounded-1 p-2" name="light_bg_secondary_color" onChange={handleInput} value={editUser?.light_bg_secondary_color}></input>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

          </Wrapper>
          {/* Admin button Text color end */}






          <Wrapper>
            <MessageHeading text="Admin Button color" />
            <div className="d-flex align-items-center justify-content-between  ">
              <MessageLabel text="Dark Mode" />
              {/* <MessageLabel text="Light Mode" /> */}
            </div>
            <div className="d-flex align-items-center justify-content-between gap-2  mb-4 ">
              <div className="d-flex align-items-center gap-3">
                <div className="pickerWidth">
                  <label className="m-0 colorText d-block text-center text-secondary">Button color</label>
                  <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                    <input
                      type="color"
                      className="rs-input form-control-lg p-0 border colorPicker"
                      id="button_bg_color"
                      name="button_bg_color"
                      onChange={handleInput}
                      value={editUser?.button_bg_color}
                    />
                    <input type="text" className="showCode theme-bg-color-secondary  d-block  w-100 rounded-1 p-2" name="button_bg_color" onChange={handleInput} value={editUser?.button_bg_color}></input>
                  </div>
                </div>

                {/* <div className="pickerWidth">
                  <label className="m-0 colorText d-block text-center text-secondary">Text color</label>
                  <div className="mt-2  overflow-hidden shadow  rounded-2">
                    <input
                      type="color"
                      className="rs-input form-control-lg p-0  colorPicker "
                      id="admin_dark_button_text_color"
                      name="admin_dark_button_text_color"
                      onChange={handleInput}
                      value={editUser?.admin_dark_button_text_color}
                    />
                    <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="admin_dark_button_text_color" onChange={handleInput} value={editUser?.admin_dark_button_text_color}></input>
                  </div>
                </div> */}
              </div>
              {/* <div className="d-flex align-items-center gap-3">
                <div className="pickerWidth">
                  <label className="m-0 colorText d-block text-center text-secondary">Button color</label>
                  <div className="mt-2  overflow-hidden shadow  rounded-2">
                    <input
                      type="color"
                      className="rs-input form-control-lg p-0  colorPicker "
                      id="admin_light_button_bg_color"
                      name="admin_light_button_bg_color"
                      onChange={handleInput}
                      value={editUser?.admin_light_button_bg_color}
                    />
                    <input type="text" className="showCode theme-bg-color-secondary d-block  w-100 rounded-1 p-2" name="admin_light_button_bg_color" onChange={handleInput} value={editUser?.admin_light_button_bg_color}></input>
                  </div>
                </div>
                <div className="pickerWidth">
                  <label className="m-0 colorText d-block text-center text-secondary">Text color</label>
                  <div className="mt-2 rounded-3 overflow-hidden shadow  rounded-2 ">
                    <input
                      type="color"
                      className="rs-input form-control-lg p-0 border colorPicker"
                      id="admin_light_button_text_color"
                      name="admin_light_button_text_color"
                      onChange={handleInput}
                      value={editUser?.admin_light_button_text_color}
                    />
                    <input type="text" className="showCode theme-bg-color-secondary  d-block  w-100 rounded-1 p-2" name="admin_light_button_text_color" onChange={handleInput} value={editUser?.admin_light_button_text_color}></input>
                  </div>
                </div>
              </div> */}
            </div>
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text="Site Logo" />
            <MessageLabel text="Dark Mode" />
            <MessageSubHeading className="colorText" text="Select the logo image( 5:1 Ratio or 200x40px )" />
            {loading ? (<Response_Loading_processing></Response_Loading_processing>) : (<img src={editUser?.dark_mode_logo} alt="Image" className="thumbnails-images-theme-setting" />)}
            <div className="mx-0 row mb-3">
              <div className="col-6 ps-0">
                <div
                  className={`imagedrop theme-border-color ${error1 ? "border-danger  dotted-border-border-border" : ""}`}
                  onClick={() => fileInputRef1.current.click()}
                >
                  <input
                    type="file"
                    name="dark_mode_logo"
                    ref={fileInputRef1}
                    onChange={(event) => handleFileChange(event, fileInputRef1, setSelectedFile1, setError1)}
                    accept="image/*"
                    style={{ display: "none" }}
                  />
                  <label className="theme-text-color">
                    <CameraRetroIcon className="theme-text-color" />
                  </label>
                </div>
                {error1 && <p className="text-danger-dotted-red mt-1">{error1}</p>}
              </div>

              <div className="col-6">
                <div>
                  {selectedFile1 && (
                    <div className="imagedropcopy theme-border-color  text-end">
                      <div className="row m-0">
                        <div className="col-10 p-0">
                          <img src={URL.createObjectURL(selectedFile1)} alt="Uploaded" className="thumbnails-upload-images object-fit-contain" />
                        </div>
                        <div className="col-2 p-0" style={{ alignSelf: "center" }} >
                          <button onClick={() => handleDelete(1)} type="button" className=" theme-text-color bg-transparent " ><IoClose className="custom-close-btn" /></button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>


            <MessageLabel text="Light Mode" />
            <MessageSubHeading className="colorText" text="Select the logo image( 5:1 Ratio or 200x40px )" />
            {loading ? (<Response_Loading_processing></Response_Loading_processing>) : (<img src={editUser?.light_mode_logo} alt="Image" className="thumbnails-images-theme-setting" />)}
            <div className="mx-0 row mb-3">
              <div className="col-6 ps-0">
                <div
                  className={`imagedrop theme-border-color ${error2 ? "border-danger  dotted-border-border-border" : ""}`}
                  onClick={() => fileInputRef2.current.click()}
                >
                  <input
                    type="file"
                    name="light_mode_logo"
                    ref={fileInputRef2}
                    onChange={(event) => handleFileChange(event, fileInputRef2, setSelectedFile2, setError2)}
                    accept="image/*"
                    style={{ display: "none" }}
                  />
                  <label className="theme-text-color">
                    <CameraRetroIcon className="theme-text-color" />
                  </label>
                </div>
                {error2 && <p className="text-danger-dotted-red mt-1">{error2}</p>}
              </div>

              <div className="col-6">
                <div>
                  {selectedFile2 && (
                    <div className="imagedropcopy theme-border-color  text-end">
                      <div className="row m-0">
                        <div className="col-10 p-0">
                          <img src={URL.createObjectURL(selectedFile2)} alt="Uploaded" className="thumbnails-upload-images object-fit-contain" />
                        </div>
                        <div className="col-2 p-0" style={{ alignSelf: "center" }} >
                          <button onClick={() => handleDelete(2)} type="button" className=" theme-text-color bg-transparent " ><IoClose className="custom-close-btn" /></button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <MessageLabel text="Gif Loader" />
            {loading ? (<Response_Loading_processing></Response_Loading_processing>) : (<img src={editUser?.loading_gif_video} alt="Image" className="thumbnails-images-theme-setting" />)}
            <div className="mx-0 row">
              <div className="col-6 ps-0">
                <div className="imagedrop theme-border-color" onClick={() => fileInputRef3.current.click()} >
                  <input type="file" name="loading_gif_video" ref={fileInputRef3} onChange={(event) => handleFileChange(event, fileInputRef3, setSelectedFile3, null, false)} accept="image/*" style={{ display: "none" }} />
                  <label className=" theme-text-color">
                    <CameraRetroIcon className="theme-text-color" />
                  </label>
                </div>
              </div>
              <div className="col-6">
                <div>
                  {selectedFile3 && (
                    <div className="imagedropcopy theme-border-color  text-end">
                      <div className="row m-0">
                        <div className="col-10 p-0">
                          <img src={URL.createObjectURL(selectedFile3)} alt="Uploaded" className="thumbnails-upload-images object-fit-contain" />
                        </div>
                        <div className="col-2 p-0" style={{ alignSelf: "center" }} >
                          <button onClick={() => handleDelete(3)} type="button" className=" theme-text-color bg-transparent " ><IoClose className="custom-close-btn" /></button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>


            {/* 
            <div className="text-start mt-2">
              <label className="m-0">Gif Video</label>

              <div className="">
                {loading ? (
                  <Response_Loading_processing></Response_Loading_processing>
                ) : (
                  <img
                    src={editUser?.loading_gif_video_url}
                    // alt="Image"
                    className="thumbnails-images-theme-setting"
                  />
                )}
              </div>
              <div className="mt-2">
                <div className="col-lg-12 row">
                  <div className="col-6 col-sm-6 col-lg-6">
                    <input
                      type="file"
                      style={{ width: "auto" }}
                      className="form-control-lg rs-input"
                      name="loading_gif_video_url"
                      onChange={(e) => setloading_gif_video_url(e.target.files[0])}
                      multiple
                    />
                  </div>
                </div>
              </div>
            </div> */}

          </Wrapper >
          {/* <Wrapper>
            <MessageHeading text="Theme Switcher" />
            <select name="current_theme" value={editUser?.current_theme} onChange={handleInput} className="form-select mb-3 custom-placeholder   border border-1 theme-border-color  theme-text-color" >
              {themeList?.map((item) => <option value={item?.theme_slug} className="theme-bg-color theme-text-color">{item?.theme_name}</option>)}
            </select>
          </Wrapper> */}
          <Wrapper>
            <MessageHeading text="Status Settings" />
            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Developer Tools" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'prevent_inspect'} checked={editUser?.prevent_inspect == 1} onChange={handleInputenable} />
              </div>
            </div>
            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Loader" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'loader_setting'} checked={editUser?.loader_setting == 1} onChange={handleInputenable} />
              </div>
            </div>
            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Audio Page Checkout" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'audio_page_checkout'} checked={editUser?.audio_page_checkout == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Signin Header" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'signin_header'} checked={editUser?.signin_header == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Translate Checkout" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'translate_checkout'} checked={editUser?.translate_checkout == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Audio Content Right Checkout" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'audio_content_right_checkout'} checked={editUser?.audio_content_right_checkout == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Partner Page" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'partner_checkout'} checked={editUser?.partner_checkout == 1} onChange={handleInputenable} />
              </div>
            </div>


            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Partner VOD/AOD" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'Vod_Aod_checkout'} checked={editUser?.Vod_Aod_checkout == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Header Top Position" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'header_top_position'} checked={editUser?.header_top_position == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Header Side Position" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'header_side_position'} checked={editUser?.header_side_position == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Extract Images" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'enable_extract_image'} checked={editUser?.enable_extract_image == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Bunny CDN Option" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'enable_bunny_cdn'} checked={editUser?.enable_bunny_cdn == 1} onChange={handleInputenable} />
              </div>
            </div>
            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Frontend Hover Theme Slider " />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'enable_slider'} checked={editUser?.enable_slider == 1} onChange={handleInputenable} />
              </div>
            </div>
            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Multi PPV Resolution" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'enable_ppv_based_resolution'} checked={editUser?.enable_ppv_based_resolution == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Subscription Flag" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'subscription_flag'} checked={editUser?.subscription_flag == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Movie Stripe Tag" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'movie_stripe'} checked={editUser?.movie_stripe == 1} onChange={handleInputenable} />
              </div>
            </div>
            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Disable Frontend Login " />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'disable_login'} checked={editUser?.disable_login == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Radio Station" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'radiostation_active'} checked={editUser?.radiostation_active == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable EPG" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'enable_epg'} checked={editUser?.enable_epg == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Watch Later status" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'watchlater_status'} checked={editUser?.watchlater_status == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Wishlist status" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'wishlist_status'} checked={editUser?.wishlist_status == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Category hover" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'category_hover'} checked={editUser?.category_hover == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Trailer hover" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'trailer_hover'} checked={editUser?.trailer_hover == 1} onChange={handleInputenable} />
              </div>
            </div>
            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Trailer On Banner" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'enable_trailer_banner'} checked={editUser?.enable_trailer_banner == 1} onChange={handleInputenable} />
              </div>
            </div>
            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Information Banner" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'maintenance_banner_enabled'} checked={editUser?.maintenance_banner_enabled == 1} onChange={handleInputenable} />
              </div>
            </div>
            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Disable Divider" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'disable_divider'} checked={editUser?.disable_divider == 1} onChange={handleInputenable} />
              </div>
            </div>
            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Disable 404 Screen" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'disable_404_screen'} checked={editUser?.disable_404_screen == 1} onChange={handleInputenable} />
              </div>
            </div>
            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Livestream Notification" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'livestream_notification'} checked={editUser?.livestream_notification == 1} onChange={handleInputenable} />
              </div>
            </div>
            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Category Tab" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'enable_category_tab'} checked={editUser?.enable_category_tab == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable SSAI Ads" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name='ssai_enable' checked={editUser?.ssai_enable == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <div className="d-flex align-items-center">
                  <MessageLabel text="Enable Image Cropping" noMargin />
                  <span
                    className="ms-2"
                    style={{
                      fontSize: "10px",
                      backgroundColor: "#f59e0b",
                      color: "#fff",
                      padding: "2px 6px",
                      borderRadius: "999px",
                      fontWeight: "600",
                      height: "fit-content"
                    }}
                  >
                    BETA
                  </span>
                </div>              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch
                  name="enable_image_cropping"
                  checked={editUser?.enable_image_cropping === 1}
                  onChange={handleInputenable}
                />
              </div>
            </div>
            {/* <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Enable Profile Settings" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'my_profile_theme'} checked={editUser?.my_profile_theme == 1} onChange={handleInputenable} />
              </div>
            </div> */}
          </Wrapper>
          <Wrapper>

            <MessageLabel className="fw-bold" text="Plan Page" />

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Subscription Plan Enable" />
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'subscription_plan_enable'} checked={editUser?.subscription_plan_enable == 1} onChange={handleInputenable} />
              </div>
            </div>
          </Wrapper>
          <Wrapper>

            <MessageLabel className="fw-bold" text="Partner Approval Settings" />

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Partner Approval" />
                <small style={{ fontSize: "11px", opacity: 0.6, display: "block", marginTop: "2px" }}>(When enabled, admin approval is required for new partner registrations.)</small>
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'partner_approval'} checked={editUser?.partner_approval == 1} onChange={handleInputenable} />
              </div>
            </div>

            <div className="row mx-0 mb-3">
              <div className="col-9 ps-0">
                <MessageLabel text="Partner Content Approval" />
                <small style={{ fontSize: "11px", opacity: 0.6, display: "block", marginTop: "2px" }}>(When enabled, partner-uploaded content requires admin approval before publishing.)</small>
              </div>
              <div className="col-3 text-end pe-0">
                <AdminSwitch name={'partner_content_approval'} checked={editUser?.partner_content_approval == 1} onChange={handleInputenable} />
              </div>
            </div>
          </Wrapper>
        </RightWrapper >
        <AdminCustomButton saveMethod={handleSave} saveText="Update Settings" className="ms-auto" />
      </FormContainer >
    </>
  );
}

export default ThemeSettings;